<template>
	<!-- v-if="detail" -->
	<div class="purchase_service">
		<!--检测人信息-->
		<base-card title="检测人信息" title-icon="infor.png">
			<van-field
				class="form-item"
				input-align="right"
				v-model="params.name"
				placeholder="请输入真实姓名"
			>
				<template #label>
					<p>真实姓名</p>
					<p class="van-cell__desc">点击修改姓名</p>
				</template>
			</van-field>
			<van-field
				class="form-item"
				input-align="right"
				v-model="params.idcard"
				label="身份证号"
				maxlength="18"
				placeholder="请输入身份证号"
			/>
		</base-card>
		<!--临床信息 -->
		<base-card
			v-if="detail.zoneType === 2"
			class="mt-28"
			title="临床信息"
			title-icon="list.png"
			title-icon-width="23"
		>
			<van-field
				readonly
				class="form-item ellipsis"
				input-align="right"
				v-model="params.diagnose"
				label="临床症状"
				placeholder="请输入临床症状"
				@click-input="$refs.diagnose.show = true"
			/>
			<van-field
				readonly
				class="form-item"
				input-align="right"
				label="用药信息"
				maxlength="18"
				:value="params.drugList && params.drugList.length > 0 ? '点击查看' : ''"
				placeholder="请选择用药信息"
				@click-input="$refs.drugInfo.init()"
			/>
		</base-card>

		<!--检测中心-->
		<base-card
			class="mt-28"
			:title="detail.organName"
			title-icon="institution.png"
			title-icon-width="23"
		>
			<infor-card
				:list="detail.productList || []"
				:total-price="detail.totalPrice"
				:sample-type="getSampleType"
			></infor-card>
		</base-card>

		<export-parse :detail="detail"></export-parse>

		<foot-button customClass="cus-foot">
			<van-checkbox
				shape="square"
				icon-size="18px"
				v-model="checked"
				class="check"
			>
				我已阅读并同意
				<span @click="viewAgreement" style="color:#15c5ce;"
					>《抗体检测知情同意书》</span
				>
			</van-checkbox>
			<van-button type="primary" block @click="clickPay"
				>立即购买</van-button
			>
		</foot-button>

		<van-popup
			v-model="showAgr"
			position="bottom"
			:close-on-popstate="true"
			round
			:style="{ height: '90vh' }"
		>
			<agreement :productList="this.detail.productList" @close="close" />
		</van-popup>

		<diagnose ref="diagnose" v-model="params.diagnose" />

		<drug-info
			ref="drugInfo"
			:drugList="params.drugList"
			:otherDrugs="params.otherDrugs"
			@getDrugInfo="getDrugInfo"
		/>
	</div>
</template>

<script>
	import Agreement from './agreement'
	import Diagnose from './components/Diagnose'
	import DrugInfo from './components/DrugInfo'
	 import ExportParse from './components/reportParse.vue'
	export default {
	  name: 'PurchaseService',
	  components: { Agreement, Diagnose, DrugInfo, ExportParse },
	  data: () => ({
	    detail: {},
	    params: {
	      name: '',
	      idcard: '',
	      diagnose: '',
	      drugList: [],
	      otherDrugs: '',
	    },
	     checkedExportParse: true,
	    checked: false,
	    showAgr: false,
	    showDiagnose: false,
	  }),
	  created() {
	    this.getDetail()
	  },
	  computed: {
	    getSampleType() {
	      return (this.detail.detectType || '').split('&').map(item => (this.$store.state.account.detectType[item])).join('+')
	    }
	  },
	  methods: {
	    async getDetail() {
	      const res = await this.$api.order.detail(this.$route.params.id)
	      if (!res.code) {
	        if (res.data.detectStatus != 0) {
	          await this.$router.replace(`/purchase/success/${this.$route.params.id}`)
	          return
	        }
	        res.data.productList = res.data.productList.map(item => ({
	          ...item,
	          title: item.productName,
	          content: (item.itemList || []).map(val => val.itemName).join('、'),
	          desc: [{ label: `￥${this.$utils.priceFilter(item.totalPrice)}`, value: `x${item.quantity}` }]
	        }))
	        this.$set(this.params, 'name', res.data.patientName || '')
	        this.$set(this.params, 'diagnose', res.data.diagnose || '')
	        this.$set(this.params, 'drugList', res.data.drugList || [])
	        this.$set(this.params, 'otherDrugs', res.data.otherDrugs || '')

	        this.detail = res.data

	      } else if (res.code == 500002) {
	        this.$dialog.alert({
	          title: '',
	          message: res.msg
	        }).then(() => {
	          this.$utils.windowClose()
	        })
	      }
	    },
	    getDrugInfo(drugList, otherDrugs) {
	      this.params.drugList = drugList
	      this.params.otherDrugs = otherDrugs
	    },

	    // 点击立即购买
	    clickPay() {
	      const _this = this
	      if (!_this.checked) {
	        _this.$toast('请阅读并勾选页面协议')
	        return
	      }

	      let params = {
          appId: this.$config.appid,
	        idCard: this.params.idcard,
	        name: this.params.name,
	        openId: this.$store.getters['account/getOpenid'],
	        orderId: this.$route.params.id,
	        diagnose: this.params.diagnose,
	        drugList: this.params.drugList,
	        otherDrugs: this.params.otherDrugs,
	        callBackUrl: window.location.origin
	           + `/static/pay-result/index.html?url=`
	           + decodeURIComponent(`/order/detail/${this.$route.params.id}`)
	           + `&err=`
	           + decodeURIComponent(`/order/detail/${this.$route.params.id}`)
	           + `&orderId=${this.$route.params.id}`
	      }
	      this.$wx.wxPay(params, (res) => {
	        window.location.href = res.data.webPayUrl;
	        // if (res.err_msg == 'get_brand_wcpay_request:ok') {
	        //   _this.$router.replace(`/purchase/success/${_this.$route.params.id}`)
	        // } else {
	        //   _this.$message.error('支付失败')
	        // }
	      })
	    },
	    viewAgreement(e) {
	      this.showAgr = true
	      e.stopPropagation()
	    },
	    close() {
	      this.checked = true
	      this.showAgr = false
	    },

	  }
	}
</script>

<style scoped lang="less">
	.purchase_service {
	   padding: 32px;
	   min-height: calc(100vh - 216px);
	}
</style>
<style lang="less">
	.purchase_service {
	  .van-cell__title {
	    flex: 0 0 160px;
	  }

	  .van-cell__value {
	    flex: auto;
	    text-overflow: ellipsis;

	    .van-field__body {
	      .van-field__control--right {
	        text-overflow: ellipsis;
	      }
	    }
	  }
	}

	.cus-foot {
	  flex-direction: column !important;
	  padding-bottom: 20px;
	}

	.check {
	  font-size: 26px;
	  margin-bottom: 20px;
	}
</style>
